/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StripeStatus = "MORE_REQUIRED" | "NOT_STARTED" | "ONBOARDED" | "%future added value";
export type AccountOptionsDropdown_account = {
    readonly id: string;
    readonly name: string;
    readonly userMembership: {
        readonly isDefault: boolean;
    };
    readonly merchant: {
        readonly payments: {
            readonly stripeSetupStatus: StripeStatus;
        } | null;
    } | null;
    readonly " $refType": "AccountOptionsDropdown_account";
};
export type AccountOptionsDropdown_account$data = AccountOptionsDropdown_account;
export type AccountOptionsDropdown_account$key = {
    readonly " $data"?: AccountOptionsDropdown_account$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountOptionsDropdown_account">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountOptionsDropdown_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountMembershipResponse",
      "kind": "LinkedField",
      "name": "userMembership",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isDefault",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Merchant",
      "kind": "LinkedField",
      "name": "merchant",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Payments",
          "kind": "LinkedField",
          "name": "payments",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stripeSetupStatus",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};
(node as any).hash = '13db282a3c3cf7100ad366de07d2dbf7';
export default node;
